import request from 'supertest'
import { app } from '@/infra/app'
import { prismaService as prisma } from '@/infra/database/prisma'
import { LeadFactory } from '../../../../../test/factories/makeLead'
import { OriginFactory } from 'test/factories/makeOrigin'

describe('Fetch Leads By Origin (E2E)', () => {
  let leadFactory: LeadFactory
  let originFactory: OriginFactory
  beforeEach(async () => {
    leadFactory = new LeadFactory(prisma)
    originFactory = new OriginFactory(prisma)
  })

  test('[GET] /leads/origin/:originId/list', async () => {
    const origin = await originFactory.makePrismaOrigin({
      name: 'Test e2e'
    })
    await Promise.all([
      leadFactory.makePrismaLead({
        email: `email1@mail.com`,
        originId: origin.id
      }),
      leadFactory.makePrismaLead({
        email: `email2@mail.com`,
        originId: origin.id
      }),
      leadFactory.makePrismaLead({
        email: `email3@mail.com`,
        originId: origin.id
      }),
      leadFactory.makePrismaLead({
        email: `email4@mail.com`,
        originId: origin.id
      }),
      leadFactory.makePrismaLead({
        email: `email5@mail.com`,
        originId: origin.id
      }),
      leadFactory.makePrismaLead({
        email: `email6@mail.com`,
        originId: origin.id
      }),
      leadFactory.makePrismaLead({
        email: `email7@mail.com`,
        originId: origin.id
      }),
      leadFactory.makePrismaLead({
        email: `email8@mail.com`,
        originId: origin.id
      }),
    ])

    const response = await request(app)
    .get(`/leads/origin/list`)
    .query({
      originName: 'Test e2e',
      page: 2,
      limit: 5,
      orderBy: 'EMAIL'
    })
    .set('Authorization', `Bearer F5D9`)
    .send()

    expect(response.status).toBe(200)
    expect(response.body.leads.length).toBe(3)
    expect(response.body.leads[0].email).toEqual('email6@mail.com')
  })
  afterEach(async () => {
    await prisma.lead.deleteMany()
    await prisma.origin.deleteMany()
  })
})